<template>
  <div class>
    <STable ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :selection="false"
      label-width="100px"
    />
    <el-dialog
      v-dialogDrag
      title="审核通过"
      :visible.sync="passDialogVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form :model="passForm">
        <el-form-item label="开票信息:">
          <el-input
            v-model="passForm.reason"
            type="textarea"
            :rows="4"
            placeholder="请输入开票信息"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="savePass">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      title="驳回申请"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form :model="form">
        <el-form-item label="驳回原因:">
          <el-input
            v-model="form.reason"
            type="textarea"
            :rows="4"
            placeholder="请输入驳回原因"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import x from ''
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Kaipiaoshenpi',
  components: {},
  data() {
    return {
      form: { reason: '' },
      passForm: { reason: '' },
      dialogVisible: false,
      passDialogVisible: false,
      id: '',
      url: '/business/billing/page?unit=false',
      columns: [
        {
          label: '申请用户',
          prop: 'userName'
        },
        {
          label: '电费',
          prop: 'elecMoney',
          template: (index, record) => {
            return record.elecMoney.toFixed(2)
          }
        },
        {
          label: '服务费',
          prop: 'serviceMoney',
          template: (index, record) => {
            return record.serviceMoney.toFixed(2)
          }
        },
        {
          label: '发票形式',
          prop: 'invoiceForm',
          width: '120px',
          template: (index, record) => {
            return record.invoiceForm === '0' ? '增值税普通发票' : '增值税专用发票'
          }
        },
        {
          label: '发票抬头',
          prop: 'companyName'
        },
        {
          label: '税号',
          prop: 'taxNo'
        },
        {
          label: '开户行名称',
          prop: 'openBankName'
        },
        {
          label: '开户行账号',
          prop: 'openBankAccountNo'
        },
        {
          label: '注册地址',
          prop: 'registerAddress'
        },
        {
          label: '电话',
          prop: 'mobile'
        },
        {
          label: '申请时间',
          prop: 'applicantTime'
        },
        {
          label: '开票状态',
          prop: 'taxStatus',
          template: function(index, reocrd) {
            return reocrd.taxStatus == '0'
              ? "<span class='tag success'>可开票</span>"
              : (reocrd.taxStatus == '1' ? "<span class='tag success'>待开票</span>" : (reocrd.taxStatus == '2' ? "<span class='tag danger'>已驳回</span>" : "<span class='tag success'>已开票</span>"))
          }
        }
      ],
      // 操作栏
      handles: {
        width: 220,
        btns: [
          {
            label: '通过',
            permission: 'finance.invoice.adopt',
            getLabelStyle: record => {
              return (record.taxStatus == '2' || record.taxStatus == '3') ? 'color: #c0c4cc;cursor: not-allowed;' : ''
            },
            getLabelDisabled: record => {
              return !!((record.taxStatus == '2' || record.taxStatus == '3'))
            },
            before: (index, record) => {
              this.id = record.id
            },
            handle: resp => {
              this.passDialogVisible = true
              // this.$refs.tableref.queryTable();
            }
          },
          {
            label: '驳回',
            permission: 'finance.invoice.reject',
            style: 'color:red',
            getLabelStyle: record => {
              return (record.taxStatus == '2' || record.taxStatus == '3') ? 'color: #c0c4cc;cursor: not-allowed;' : 'color:red'
            },
            getLabelDisabled: record => {
              return !!((record.taxStatus == '2' || record.taxStatus == '3'))
            },
            before: (index, record) => {
              this.id = record.id
            },
            handle: resp => {
              this.dialogVisible = true
              // this.backApply();
            }
          },
          {
            label: '详情',
            permission: 'finance.invoice.details',
            handle: resp => {
              this.$router.push({ path: './invoiceDetail', query: { data: resp.id }})
            }
          }
        ]
      },
      query: [
        {
          label: '开票状态',
          prop: 'taxStatus',
          type: 'select',
          placeholder: '请选择开票状态',
          data: [
          // {
          //   value: '0',
          //   label: '可开票'
          // },
            {
              value: '1',
              label: '待开票'
            }, {
              value: '2',
              label: '已驳回'
            }, {
              value: '3',
              label: '已开票'
            }]
        },
        {
          label: '申请用户',
          prop: 'userName',
          placeholder: '请输入申请用户'
        },
        {
          label: '发票形式',
          prop: 'invoiceForm',
          type: 'select',
          placeholder: '请选择发票形式',
          data: [{
            value: '1',
            label: '增值税专用发票'
          }, {
            value: '0',
            label: '增值税普通发票'
          }]
        },
        {
          label: '申请时间',
          prop: 'applicantTime',
          placeholder: '',
          type: 'date2'
        }
        // {
        //   label: '发票抬头',
        //   prop: 'companyName',
        //   placeholder: '请输入发票抬头'
        // },
        // {
        //   label: '税号',
        //   prop: 'taxNo',
        //   placeholder: '请输入税号'
        // },
        // {
        //   label: '开户行名称',
        //   prop: 'openBankName',
        //   placeholder: '请输入开户行名称'
        // },
        // {
        //   label: '开户行账号',
        //   prop: 'openBankAccountNo',
        //   placeholder: '请输入开户行账号'
        // },
        // {
        //   label: '注册地址',
        //   prop: 'registerAddress',
        //   placeholder: '请输入注册地址'
        // },
        // {
        //   label: '电话',
        //   prop: 'mobile',
        //   placeholder: '请输入电话'
        // }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    save() {
      const data = {
        id: this.id,
        reason: this.form.reason
      }
      this.$store.dispatch('form/handle', {
        url: '/business/billing/reject',
        data: data,
        method: 'post',
        callback: resp => {
          this.dialogVisible = false
          this.id = ''
          this.$refs.tableref.queryTable()
        }
      })
    },
    savePass() {
      const data = {
        id: this.id,
        reason: this.passForm.reason
      }
      console.log(data)
      this.$store.dispatch('form/handle', {
        url: '/business/billing/pass',
        data: data,
        method: 'post',
        callback: resp => {
          this.passDialogVisible = false
          this.id = ''
          this.$refs.tableref.queryTable()
        }
      })
    }
    // backApply
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
.detail {
  .item {
    width: 33%;
    height: 50px;
    float: left;
    border: 1px solid #dddddd;
    text-align: center;

    .label {
      width: 100px;
      height: 50px;
      float: left;
      background: #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
      color: #000;
    }

    .value {
      // line-height: 50px;
      font-size: 14px;
      margin-top: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .value:hover {
      height: auto;
      white-space: normal;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/invoiceApproval.vue